import * as React from 'react';
import { TextInput, EMPTY_TEXT, FileInputCaptureEnum } from '@mitchell/react.component.ux';
import { EnterpriseDocStoreService } from "../../../common";
import { ConnectedFileInput } from "../../../file";
import { ADD_COMMENTS_PLACEHOLDER } from "../../../brandedNotification";
import { IntelligentPhotoCapturePhotoPreviewConstants, IntelligentPhotoCapture, PhotoCaptureConstants, PhotoCaptureAllowedMimeTypeConstant, IntelligentPhotoCaptureAddViewConstants, INTELLIGENT_MAX_CHARACTER } from '../../constants';
import { IntelligentPhotoCaptureViewType, PhotoCapture, PhotoCaptureAttributeType } from '../../enums';
import { getScreenTitleText, getNavigationMultipleButtonProps, getFileDescriptionByAttributeType, getAttachmentIdentifier, getPhotoCaptureCurrentAttachmentData, isInvalidFile, photoCaptureAllowedMimeType, getPhotoCaptureProgressiveCurrentAttachmentData, getProgressiveAttachmentIdentifier, isPrgCompanyCode, shouldEnableOCR, getImageByDescription, attachOCRExtractedDataToComment, getOCRAppendedComment, getPRGImageByDescription, getIQAHistoryDetails, getFolderModelInfo } from '../../utilities';
import { IntelligentPhotoCaptureScreenTitle } from './IntelligentPhotoCaptureScreenTitle';
import { IntelligentPhotoCaptureImageSection } from './IntelligentPhotoCaptureImageSection';
import { StyledActionButtonContainer, StyledImageContainerBox, StyledImageDetailModal, StyledImageModalBox, StyledRefreshIconSpan } from './IntelligentPageGuidanceInfo.style';
import { IntelligentPBEContainerComponent } from './IntelligentPBEContainerComponent';
export const IntelligantPhotoCaptureAddCommentView = ({ appTheme, translateFn, onViewChange, onNextQuestionClick, questionSubType, sequenceScreenName, parentQuestionId, photoCaptureAttachmentInfo, shouldShowCommentBox, files, questionnaireQuestionId, selectedImage, setSelectedImage, fileSizeLimit, imageMaxWidth, disableLibrary, companyCode, imageData, setImageData, setIsImageUpdated, moveNext, onFileUploadFailed, isMic, lastRenderedView, shouldNewImageUploaded, prgMiscImage, countryCode, ocrText, shouldEnableOCRImageTextDecode, onResetUploadedImage, shouldEnableImageQualityAssessment, updatePageAttachmentHistory, iqaScores, shouldEnableAdditionalOption, folderOptionList }) => {
    const isOcrEnabledScreen = shouldEnableOCR(questionSubType);
    const shouldRenderProgressiveContent = [
        PhotoCaptureAttributeType.WIDE_ENHANCED,
        PhotoCaptureAttributeType.CLOSEUP_ENHANCED
    ].includes(questionSubType);
    const [uploadedImage, setUploadedImage] = React.useState(selectedImage); // Internal state for Modal View(for only PRG)
    const [internalImageData, setInternalImageData] = React.useState([...imageData]);
    const [isNextButtonClick, setIsNextButtonClick] = React.useState(false);
    const fileDescription = getFileDescriptionByAttributeType(questionSubType, true, sequenceScreenName);
    const toAppendPrefix = isMic && shouldEnableOCRImageTextDecode && isOcrEnabledScreen;
    const commentPrefix = toAppendPrefix
        ? attachOCRExtractedDataToComment(questionSubType, ocrText, countryCode)
        : EMPTY_TEXT;
    const [commentText, setCommentText] = React.useState(commentPrefix ? `${commentPrefix}\n` : EMPTY_TEXT);
    const handleHistoryInfo = () => {
        if (isMic &&
            shouldEnableImageQualityAssessment && // IQA API call allowed
            !shouldEnableAdditionalOption && // IQA Display not allowed
            !isOcrEnabledScreen && // is IQA screen
            files &&
            files[0] &&
            files[0].docUID) {
            updatePageAttachmentHistory(files[0].docUID, getIQAHistoryDetails(iqaScores));
        }
    };
    React.useEffect(() => {
        handleHistoryInfo();
    }, []);
    React.useEffect(() => {
        if (selectedImage) {
            setUploadedImage(selectedImage);
            setCommentText(selectedImage.commentText || EMPTY_TEXT);
        }
    }, [selectedImage]);
    React.useEffect(() => {
        if (imageData && imageData.length) {
            setInternalImageData([...imageData]);
        }
    }, [imageData]);
    React.useEffect(() => {
        if (isNextButtonClick && imageData && imageData.length) {
            if (isOcrEnabledScreen) {
                onNextQuestionClick(questionSubType);
                moveNext();
            }
            else {
                onViewChange(IntelligentPhotoCaptureViewType.NONE, sequenceScreenName);
                onResetUploadedImage();
            }
        }
    }, [isNextButtonClick]);
    const handleTextAreaChange = (commentText) => {
        setCommentText(commentText);
        setUploadedImage((prevState) => prevState && Object.assign(Object.assign({}, prevState), { commentText }));
        // here updating the commentText in both internal useState (only for PRG)
        if (shouldRenderProgressiveContent && uploadedImage && uploadedImage.isParentImage) {
            // Update internalImageData: only update the image where damageName and isParentImage match
            setInternalImageData((prevImageData) => {
                return prevImageData.map(item => {
                    // Check if both damageName and isParentImage match
                    if (item.additionalImageTag === uploadedImage.additionalImageTag &&
                        item.isParentImage === uploadedImage.isParentImage) {
                        return Object.assign(Object.assign({}, item), { commentText // Update the commentText for the matched item
                         });
                    }
                    return item; // Otherwise return the original item
                });
            });
        }
        else {
            // Update the commentText for the image in the general mode
            if (internalImageData && internalImageData.length) {
                setInternalImageData((prevImageData) => prevImageData.map((item) => (item.fileDescription === fileDescription && Object.assign(Object.assign({}, item), { commentText })) || item));
            }
        }
    };
    // Delete Function(only for PRG)
    const onDeletePhoto = (id, additionalTag) => {
        if (internalImageData.length) {
            const selectedIndex = internalImageData.findIndex(item => item.docUID === id && item.additionalImageTag === additionalTag);
            if (selectedIndex !== -1) {
                const newArray = [...internalImageData]; // Create a new array to maintain immutability
                newArray.splice(selectedIndex, 1);
                setUploadedImage({});
                setSelectedImage && setSelectedImage({});
                setInternalImageData(newArray);
                setImageData(newArray);
                setIsImageUpdated(true);
                onViewChange(IntelligentPhotoCaptureViewType.NONE, sequenceScreenName);
            }
        }
    };
    const handleNextButtonClick = () => {
        if (shouldRenderProgressiveContent) {
            //when user click on Proceed the usePhotoCapture imageData Update(only for the PRG)
            if (setSelectedImage && uploadedImage) {
                setSelectedImage(uploadedImage);
                setImageData(internalImageData);
                setIsImageUpdated(true);
                onViewChange(IntelligentPhotoCaptureViewType.NONE, sequenceScreenName);
                onResetUploadedImage();
            }
        }
        else {
            setImageData(internalImageData);
            setIsImageUpdated(true);
            setIsNextButtonClick(true);
        }
    };
    const handleBackButtonClick = () => {
        const viewType = (!isMic && shouldRenderProgressiveContent && IntelligentPhotoCaptureViewType.NONE) ||
            IntelligentPhotoCaptureViewType.CAMERA;
        if (shouldRenderProgressiveContent) {
            if (selectedImage && setSelectedImage) {
                setSelectedImage(selectedImage);
            }
            setImageData(imageData);
        }
        onViewChange(viewType, sequenceScreenName);
    };
    const multipleButtonProps = Object.assign(Object.assign({}, getNavigationMultipleButtonProps({
        appTheme: Object.assign(Object.assign({}, appTheme), { selectedButtonBackgroundColor: appTheme.buttonBackgroundColor }),
        onLeftClick: () => handleBackButtonClick(),
        onRightClick: () => handleNextButtonClick()
    })), (!isMic &&
        shouldRenderProgressiveContent && {
        rightButtonLabel: PhotoCaptureConstants.PROCEED_BUTTON,
        leftButtonLabel: PhotoCaptureConstants.BACK,
        leftButtonIcon: ''
    }));
    const onFileUploadedSuccess = (files, panelName, isParentImage, additionalImageTag, fileMetadataDesc, damageId, panelParentIdentifier) => {
        if (files && files.length && !isInvalidFile(files)) {
            const attachmentIdentifier = getProgressiveAttachmentIdentifier(photoCaptureAttachmentInfo, internalImageData, isParentImage, isParentImage ? panelName : additionalImageTag);
            let parentIdentifier = 0;
            if (isParentImage) {
                parentIdentifier = attachmentIdentifier;
            }
            else {
                const parentImage = internalImageData.find(image => image.parentIdentifier === panelParentIdentifier);
                if (parentImage && parentImage.parentIdentifier) {
                    parentIdentifier = parentImage.parentIdentifier;
                }
            }
            const existingImageData = getPRGImageByDescription(additionalImageTag, imageData);
            if (files[0] && files[0].thumbnail && files[0].thumbnail.docUID && files[0].docUID) {
                const currentImageData = getPhotoCaptureProgressiveCurrentAttachmentData(files[0], fileMetadataDesc, attachmentIdentifier, parentQuestionId, questionnaireQuestionId, (isMic ? existingImageData === null || existingImageData === void 0 ? void 0 : existingImageData.commentText : commentText) || EMPTY_TEXT, isParentImage ? attachmentIdentifier : parentIdentifier, isParentImage, panelName, additionalImageTag, damageId, getFolderModelInfo(damageId, folderOptionList));
                setUploadedImage(currentImageData);
                isMic && setCommentText((existingImageData && existingImageData.commentText) || EMPTY_TEXT);
                if (isParentImage) {
                    let indexToUpdate = imageData.findIndex(damage => damage.additionalImageTag === additionalImageTag && damage.isParentImage);
                    if (isMic && indexToUpdate === -1) {
                        indexToUpdate = imageData.length + 1;
                    }
                    setInternalImageData((prevData) => {
                        if (indexToUpdate >= 0 && indexToUpdate < prevData.length) {
                            prevData[indexToUpdate] = currentImageData;
                            return [...prevData];
                        }
                        else {
                            return [...prevData, currentImageData];
                        }
                    });
                }
                else {
                    const filteredImageData = imageData.filter((image) => image.attachmentIdentifier !== attachmentIdentifier);
                    setInternalImageData([...filteredImageData, currentImageData]);
                }
            }
            else {
                // Handle invalid file upload
                onFileUploadFailed();
            }
        }
    };
    const getInitialComment = () => {
        const savedImageData = getImageByDescription(fileDescription, imageData);
        if (!savedImageData)
            return commentText; // First time on comment screen
        const existingComment = savedImageData.commentText || EMPTY_TEXT;
        const savedOCRText = savedImageData.ocrText || EMPTY_TEXT;
        const isRetakeWithUpdatedOCR = ocrText !== savedOCRText;
        if (isRetakeWithUpdatedOCR && toAppendPrefix) {
            const oldPrefix = attachOCRExtractedDataToComment(questionSubType, savedOCRText, countryCode);
            const regex = new RegExp(`\\b${oldPrefix}\\b`, 'gi');
            const replacedOCRExistingComment = existingComment.replace(regex, commentPrefix);
            const finalComment = getOCRAppendedComment(replacedOCRExistingComment, commentPrefix);
            return finalComment.substring(0, 200);
        }
        // From Retake screen but without OCR update
        return existingComment;
    };
    React.useEffect(() => {
        if (!shouldRenderProgressiveContent) {
            if (files && files.length > 0 && !isInvalidFile(files)) {
                if (files[0].docUID) {
                    const initialShowComment = getInitialComment();
                    const attachmentIdentifier = getAttachmentIdentifier(photoCaptureAttachmentInfo, imageData, fileDescription);
                    const currentImage = getPhotoCaptureCurrentAttachmentData(files[0], fileDescription, attachmentIdentifier, parentQuestionId, questionnaireQuestionId, initialShowComment);
                    setUploadedImage(currentImage);
                    setCommentText(initialShowComment);
                    const filteredImageData = imageData.filter((image) => image.attachmentIdentifier !== attachmentIdentifier);
                    setInternalImageData([...filteredImageData, currentImage]);
                }
            }
            else {
                onFileUploadFailed();
            }
        }
        else if (isMic) {
            const { damageName = EMPTY_TEXT, isParentImage = false, additionalImageTag = EMPTY_TEXT, fileDescription, damageId = EMPTY_TEXT, parentIdentifier } = prgMiscImage;
            if (shouldNewImageUploaded) {
                onFileUploadedSuccess(files, damageName, isParentImage, additionalImageTag, fileDescription, damageId, parentIdentifier);
            }
        }
    }, [files, ocrText]);
    let connectedFileInputProps = Object.assign({ applicationName: PhotoCaptureConstants.PHOTO_CAPTURE_APPLICATION_NAME, companyCode: companyCode || EMPTY_TEXT, acceptedMimeTypes: photoCaptureAllowedMimeType, disabled: false, element: (React.createElement(StyledRefreshIconSpan, { id: `${IntelligentPhotoCaptureAddViewConstants.IMAGE_RETAKE_ICON}`, className: "mi-icon-refresh", isParentImage: uploadedImage && uploadedImage.isParentImage })), isDuplicateDocumentAllowed: false, scaledMaxSize: imageMaxWidth, thumbnailMaxSize: PhotoCaptureConstants.THUMBNAIL_MAX_SIZE, multiple: false, onAllFileUploadComplete: files => uploadedImage &&
            onFileUploadedSuccess(files, uploadedImage.damageName || EMPTY_TEXT, uploadedImage.isParentImage || false, uploadedImage.additionalImageTag || EMPTY_TEXT, uploadedImage.fileDescription, uploadedImage.damageId || EMPTY_TEXT, uploadedImage.parentIdentifier), id: `${PhotoCapture.PHOTO_CAPTURE}_FileUploader`, allowedFileTypes: PhotoCaptureAllowedMimeTypeConstant, maxFileSize: fileSizeLimit }, (isPrgCompanyCode(companyCode) && uploadedImage && { fileDescription: uploadedImage.fileDescription }));
    disableLibrary === PhotoCaptureConstants.Y &&
        (connectedFileInputProps = Object.assign(Object.assign({}, connectedFileInputProps), { acceptedMimeTypes: PhotoCaptureConstants.ACCEPT_IMAGE_MIME, captureMode: FileInputCaptureEnum.ENVIRONMENT }));
    const renderCommentBox = () => {
        return (React.createElement(StyledActionButtonContainer, null,
            React.createElement(TextInput, { id: `${IntelligentPhotoCapture.INTELLIGENT_GUIDED_PHOTO_CAPTURE}_${IntelligentPhotoCapturePhotoPreviewConstants.INPUT_BOX_ID}`, placeHolder: translateFn(ADD_COMMENTS_PLACEHOLDER), textLabel: EMPTY_TEXT, showRemainingCharAt: INTELLIGENT_MAX_CHARACTER, maxInputLength: INTELLIGENT_MAX_CHARACTER, required: false, value: commentText, onChange: (value) => handleTextAreaChange(value), translateFn: translateFn })));
    };
    return (React.createElement(StyledImageDetailModal, { id: (!isMic && shouldRenderProgressiveContent && `${IntelligentPhotoCaptureAddViewConstants.MAIN_CONTAINER}`) ||
            EMPTY_TEXT },
        React.createElement(StyledImageContainerBox, { id: (!isMic && shouldRenderProgressiveContent && `${IntelligentPhotoCaptureAddViewConstants.WRAPPER}`) ||
                EMPTY_TEXT },
            React.createElement(IntelligentPBEContainerComponent, Object.assign({ islanguageHide: true, appTheme: appTheme, isFooter: false, hasMultipleButton: true, btnIcon: (!shouldRenderProgressiveContent && PhotoCaptureConstants.ICON_CLASS) || undefined }, ((isMic || !shouldRenderProgressiveContent) && {
                movePrevious: () => onViewChange(lastRenderedView, sequenceScreenName)
            }), { shouldShowAvatar: isMic || !shouldRenderProgressiveContent, shouldAllowMitchellIntelligent: isMic, multipleButtonProps: multipleButtonProps }),
                (!shouldRenderProgressiveContent || isMic) && (React.createElement(IntelligentPhotoCaptureScreenTitle, { firstText: translateFn(`${IntelligentPhotoCapturePhotoPreviewConstants.PHOTO_PREVIEW_AND_COMMENT}`), secondText: translateFn(`${getScreenTitleText(questionSubType, sequenceScreenName)}`) })),
                React.createElement(StyledImageModalBox, { id: !isMic && shouldRenderProgressiveContent
                        ? `${IntelligentPhotoCaptureAddViewConstants.IMAGE_CONTAINER_BOX}`
                        : EMPTY_TEXT },
                    React.createElement(IntelligentPhotoCaptureImageSection, { additionalId: (!isMic &&
                            shouldRenderProgressiveContent &&
                            `${IntelligentPhotoCaptureAddViewConstants.WIDE_ENHANCED}`) ||
                            EMPTY_TEXT, imageSrc: EnterpriseDocStoreService.createFileUrl(shouldRenderProgressiveContent && uploadedImage && uploadedImage.docUID
                            ? uploadedImage.docUID
                            : (files && files.length && files[0].thumbnail && files[0].thumbnail.docUID) || EMPTY_TEXT), shouldShowDeleteIcon: shouldRenderProgressiveContent && uploadedImage && !uploadedImage.isParentImage, onDeleteClick: () => uploadedImage && onDeletePhoto(uploadedImage.docUID, uploadedImage.additionalImageTag || EMPTY_TEXT) }, !isMic && shouldRenderProgressiveContent ? React.createElement(ConnectedFileInput, Object.assign({}, connectedFileInputProps)) : React.createElement(React.Fragment, null))),
                shouldShowCommentBox &&
                    shouldRenderProgressiveContent &&
                    uploadedImage &&
                    uploadedImage.isParentImage &&
                    renderCommentBox(),
                shouldShowCommentBox && !shouldRenderProgressiveContent && renderCommentBox()))));
};
//# sourceMappingURL=IntelligentPhotoCaptureAddCommentView.js.map